// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-modal-modal_card-vnjoY {
  width: 340px;
  height: auto;
}

.edit-modal-modal_content-KZZdw {
  padding-bottom: 20px;
}

.edit-modal-textField_container-QNZtu, .edit-modal-password_container-MuHwV {
  width: 100%;
  margin-top: 24px;
}

.edit-modal-password_inputContainer-xdNza {
  padding-right: 4px;
}

.edit-modal-optionIcon-EJfLC {
  width: fit-content;
  height: fit-content;
  font-size: 24px;
  padding: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-user/edit-modal/edit-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.modal_content {\n  padding-bottom: 20px;\n}\n\n.textField_container, .password_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.password_inputContainer {\n  padding-right: 4px;\n}\n\n.optionIcon {\n  width: fit-content;\n  height: fit-content;\n  font-size: 24px;\n  padding: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-modal-modal_card-vnjoY`,
	"modal_content": `edit-modal-modal_content-KZZdw`,
	"textField_container": `edit-modal-textField_container-QNZtu`,
	"password_container": `edit-modal-password_container-MuHwV`,
	"password_inputContainer": `edit-modal-password_inputContainer-xdNza`,
	"optionIcon": `edit-modal-optionIcon-EJfLC`
};
export default ___CSS_LOADER_EXPORT___;
